export const projects = [
  {
    title: "Clubhouse Caddie",
    subtitle: "MERN",
    description:
      "A full stack application where the user can order food, drinks and golf supplies to your location.",
    image: "./Caddie.png",
    link: "https://sleepy-lake-08417.herokuapp.com/",
  },
  {
    title: "Space Zone",
    subtitle: "JavaScript",
    description:
      "A fun application where you are shown NASA's images and random quotes",
    image: "./space.png",
    link: "https://mmuugii.github.io/Space-Music/",
  },
  {
    title: "Daily Planner",
    subtitle: "JavaScript",
    description:
      "A simple daily planner.",
    image: "./planner.png",
    link: "https://mmuugii.github.io/Daily-Planner/",
  },
  {
    title: "Weather.4",
    subtitle: "React",
    description:
      "A weather application where you can see various details in any given city",
    image: "./weather4.png",
    link: "https://weather-4.netlify.app",
  },
  {
    title: "Progressive Text Editor",
    subtitle: "Express & Webpack",
    description: 
    "A progressive web application that is usable offline and can be downloaded to any device.",
    image: './pwa.png',
    link: "https://powerful-citadel-61159.herokuapp.com/",
  },
  {
    title: "Note Application",
    subtitle: "Express and Node",
    description: 
    "An application that utilizes node and express to take and save users' notes",
    image: './note.png',
    link: "https://note-writer-mm.herokuapp.com/",
  }
];

export const skills = [
  "Full Stack Development",
  "Front End Development",
  "Back End Development",
  "JavaScript",
  "React",
  "MongoDB",
  "NodeJS",
  "GraphQL",
  "ExpressJS",
  "RESTful API",
  "Python",
  "Django",
  "HTML/CSS",
  "Git",
];



// WEBPACK FOOTER //
// ./src/data.js